import { render, staticRenderFns } from "./servercpu.vue?vue&type=template&id=4f56e90c"
import script from "./servercpu.vue?vue&type=script&lang=js"
export * from "./servercpu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports